<template>
    <div>
        <h2 class="clearfix">
            {{ $t('edit-osce') }}
            <div class="float-right">
                <button @click="saveOSCE" class="btn btn-primary" :disabled="!osce.title">{{ $t('save') }}</button>
                <StatusSelector :osce="osce" v-if="osce.id"></StatusSelector>
            </div>
        </h2>

        <div v-if="saved">
            <div class="alert alert-success">{{ $t('saved') }}</div>
        </div>

        <div class="row">
            <div class="col-12 d-flex flex-column">
                <TextInput :label="$t('title')" v-model="osce.title" />
                <TextAreaAutosize :label="$t('description')" v-model="osce.note" />
            </div>
        </div>

        <div v-if="osce.id" class="mb-5">
            <h2 class="clearfix mb-3">
                {{ $t('stations') }}
                <router-link :to="`/settings/osce/${osce.id}/stations/`" class="btn btn-secondary float-right">{{
                    $t('new') }}</router-link>
            </h2>
            <div v-for="station in osce.stations" :key="station.id" class="list-group no-border border-radius-2 mb-3">
                <WidgetHeader :link="`/settings/osce/${osce.id}/stations/${station.id}`">{{ station.code }}: {{ station.title }}<span v-if="station.duration" class="text-muted font-weight-normal ml-2">({{ $tc('n-mins', station.duration, { n: station.duration }) }})</span>
                </WidgetHeader>
                <div v-if="station.note" class="list-group-item">{{ station.note }}</div>
            </div>
        </div>

        <div v-if="osce.stations.length" class="mb-5">
            <h2 class="clearfix mb-3">
                {{ $t('schedule') }}
                <router-link :to="`/settings/osce/${osce.id}/events/`" class="btn btn-secondary float-right">{{
                    $t('new') }}</router-link>
            </h2>
            <div v-for="event in osce.events" :key="event.id" class="list-group no-border border-radius-2 mb-3">
                <WidgetHeader :link="`/settings/osce/${osce.id}/events/${event.id}`">{{ event.date }}
                </WidgetHeader>
            </div>
        </div>
        <!-- <div v-if="osce.stations" class="mb-5">
            <h2 class="clearfix mb-3">
                {{ $t('schedule') }}
                <button 
                    class="btn btn-secondary float-right" 
                    :disabled="datestoadd.length == 0"
                    @click="saveDates" 
                >
                    {{  $t('add-dates') }} <b-icon icon="plus" />
                </button>
            </h2>
            <MultiDatePicker
                @selectedDates="handleDates"
            >
            <template v-slot:dateactions>
                <div v-if="osce.events?.length">
                <b-card class="no-border mt-2" no-body>
                    
                    <b-tabs pills card vertical end>
                        <b-tab 
                            v-for="entry in osce.events" 
                            :title="entry.date" 
                            :key="entry.date" 
                            active
                        >
                            <b-card-text>
                               <p>{{ $t('number-of-tracks') }}
                                <NumberInput 
                                    :value="entry.numtracks"
                                    :label="$t('number-of-tracks')"
                                    inputClass="form-control-sm"
                                    wrapperClass="col-1"
                                    srOnly="true"
                                    ></NumberInput>
                                </p>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
            </template>
            </MultiDatePicker> -->
            <!-- <div v-for="date in osce.date" :key="date" class="list-group no-border border-radius-2 mb-3">
                
            </div> 
        </div>-->
    </div>
</template>

<script>
import WidgetHeader from "src/components/widgets/WidgetHeader";
import StatusSelector from "../../../components/OSCE/StatusSelector.vue";
// import MultiDatePicker from "../../../components/MultiDatePicker.vue";
// import NumberInput from "../../../components/Inputs/NumberInput.vue";

export default {
    components: {
        WidgetHeader,
        StatusSelector,
        // MultiDatePicker,
        // NumberInput
    },
    mounted() {
        if (this.$route.params.id) this.fetchOSCE().then(() => this.loading = false)
    },
    data() {
        return {
            loading: !!this.$route.params.id,
            submitting: false,
            osce: {
                id: null,
                title: '',
                note: '',
                stations: [],
                learningoutcomes: [],
                status: 1,
                events: []
            },
            datestoadd: [],
            saved: false
        }
    },
    methods: {
        saveOSCE() {
            if (this.submitting) return
            this.submitting = true

            this.saved = false
            this.$store.commit('showBlockingSpinner')

            return this.$cfetch(`${this.$settings.APIBaseURL}/osce/save`, {
                method: 'POST',
                data: this.osce,
            })
            .then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error saving osce')

                if (!this.osce.id) this.$router.replace(`/settings/osce/edit/${res.result.id}`)
                else this.saved = true
            })
            .catch(err => {
                console.error(err)
                this.$log.error.call(this, err);

                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-saving-osce'),
                })
            })
            .finally(() => {
                this.$store.commit('hideBlockingSpinner')
                this.submitting = false
            })
        },
        fetchOSCE() {
            this.$store.commit('showBlockingSpinner')

            return this.$cfetch(`${this.$settings.APIBaseURL}/osce/get`, {
                method: 'GET',
                data: { id: this.$route.params.id }
            })
                .then(res => {
                    if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching osce')

                    Object.assign(this.osce, res.result) // Vue 2 reactivity strikes again.
                    
                    this.osce.events = res.result.events
                        .sort((a, b) => a.datetimefrom - b.datetimefrom)
                        .map( x => {
                            return {
                                ...x,
                                date: this.$datetime.getLocaleDateStringFromTimestamp(x.datetimefrom)
                            }
                        })
                })
                .catch(error => {
                    this.$log.error.call(this, error)
                    //this.$router.push('/settings/osce')
                })
                .finally(() => {
                    this.$store.commit('hideBlockingSpinner')
                })
        },
        handleDates(dates) {
            this.datestoadd = dates
        },
        saveDates() {
            this.osce.events = this.datestoadd.map( x => {
                return {
                    datetimefrom: `${x} 00:00:00`,
                    datetimeto: `${x} 18:00:00`,
                    date: x,
                    osce_id: this.$route.params.id
                }
            })

            this.saveOSCE()
        }
       
    },
    
}
</script>
